// ─────────────────────────────────────────────────────────────
// CENTRAL SITE CONFIGURATION — edit values here, they update everywhere.
// NOTE: CONTACT_PHONE is stored exactly as supplied by the business owner.
// It currently contains 9 digits. Update it here once the full number
// is confirmed and it will change across the entire website.
// ─────────────────────────────────────────────────────────────
const CONTACT_PHONE = "9133355571";

export const SITE = {
  name: "NRI Property Services",
  parent: "A Quality Expertz Group Company",
  domain: "nripropertyservices.in",
  url: "https://nripropertyservices.in",
  city: "Hyderabad",
  location: "Hyderabad, Telangana, India",
  serviceArea: "Hyderabad and Greater Hyderabad",

  // Contact (centralized — change once, applies site-wide)
  phone: CONTACT_PHONE,
  phoneDisplay: `+91 ${CONTACT_PHONE}`,
  phoneHref: `tel:+91${CONTACT_PHONE}`,
  whatsapp: `91${CONTACT_PHONE}`,
  whatsappDisplay: `+91 ${CONTACT_PHONE}`,
  email: "care@nripropertyservices.in",

  // Analytics — placeholder IDs. Replace with real IDs to activate.
  gaId: "G-XXXXXXXXXX",
  metaPixelId: "XXXXXXXXXXXXXXX",
};

export const DEFAULT_WA_MESSAGE =
  "Hello NRI Property Services, I am an NRI property owner and would like assistance with my property in Hyderabad.";

export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message || DEFAULT_WA_MESSAGE)}`;

export const NAV_LINKS = [
  { label: "Services", href: "/services" },
  { label: "Pricing", href: "/pricing" },
  { label: "How It Works", href: "/how-it-works" },
  { label: "FAQ", href: "/faq" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];

export const SERVICE_MENU = [
  { label: "Rental Management", href: "/rental-management" },
  { label: "Tenant Management", href: "/tenant-management" },
  { label: "Tenant Placement", href: "/tenant-placement" },
  { label: "Rent Collection", href: "/rent-collection" },
  { label: "Property Inspection", href: "/property-inspection" },
  { label: "Property Maintenance", href: "/property-maintenance" },
  { label: "Property Make-Ready", href: "/property-make-ready" },
  { label: "Move-In / Move-Out", href: "/move-in-move-out" },
  { label: "Interior & Renovation", href: "/interior-services" },
  { label: "Rental Agreement Assistance", href: "/rental-agreement-assistance" },
  { label: "Painting Services", href: "/painting-services" },
  { label: "Plumbing Services", href: "/plumbing-services" },
  { label: "Electrical Services", href: "/electrical-services" },
];
